import type { SessionFailure } from './sessionPolicy';
const listeners = new Set<(failure: SessionFailure) => void>();
let revision = 0;
/** Only allowlisted codes/status/classes cross this boundary; no response/token values. */
export const sessionEvents = {
  revision: () => revision,
  changed() {
    revision++;
  },
  publish(failure: SessionFailure) {
    for (const listener of listeners) {
      try {
        listener(failure);
      } catch {/* Observability must not change the SDK response. */}
    }
  },
  subscribe(listener: (failure: SessionFailure) => void) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }
};
